import React, {Component} from 'react';
import { withRouter } from "react-router-dom";




class PrintingLabels extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Printing Shipping Labels / Ready To Ship</h2>

                <br/>
                <h6> How to know when a label is ready: </h6>


                <br/><br/><br/>
                <div className="text-center">
                <img className='text-center' style={{ width:"100%",height:"100%"}} src='./images/DashboardClaims.png'  alt=''/> 
              
                   
                </div>



                <h6> Printing Shipping Label: </h6>
                
                <p className='text-primary'>Once a guest has completed the shipping selection and purchase of the shippin label, the label is ready to be printed.  
                
               Knowing when to print a shipping label is an important feature within the BOUNTE Venue &trade;. To know when to print a shipping label you would locate the Dashboard or the claims screen. 
                Each of these screens has an indicator for each claim listed thats display "Ready To Ship". A claim listed with the status "Ready To Ship" means the claim has a printable shipping label. Click on the claim, and located the "Print Shipping Label Button"
                
                
                
                 </p>
                <br/>

                <br/>
              
                <div className="text-center">
                    <img className='text-center' style={{width:"500px", height:"500px"}} src='./images/PrintLabelsAndLetter.png' alt=''/> 
                </div>


                 <br/> 
                 <p className='text-primary'>Click tge Print Shipping Label to display a pop-screen.  The screen will load a PDF document pre-formatted with the Venu's label format settings. (See Venue settings)</p>


                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(PrintingLabels);
